import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const [authState, setAuthState] = useState('checking');

  useEffect(() => {
    const resolveLocalAuthState = (user) =>
      user?.profilePicture ? 'authed' : 'profile';

    const raw = localStorage.getItem('user');
    const rememberToken = localStorage.getItem('rememberToken');
    if (!raw) {
      setAuthState('signin');
      return;
    }

    let user;
    try {
      user = JSON.parse(raw);
    } catch (error) {
      localStorage.removeItem('user');
      localStorage.removeItem('rememberToken');
      setAuthState('signin');
      return;
    }

    const apiUrl = process.env.REACT_APP_API_URL;
    if (!apiUrl || !navigator.onLine) {
      setAuthState(resolveLocalAuthState(user));
      return;
    }

    fetch(`${apiUrl}/check-auth.php`, {
      headers: rememberToken
        ? {
            'X-Remember-Token': rememberToken
          }
        : undefined,
      credentials: 'include',
      cache: 'no-store'
    })
      .then(async (response) => {
        const data = await response.json().catch(() => ({}));
        const isExplicitInvalid =
          response.status === 401 ||
          response.status === 403 ||
          (response.ok && data?.valid === false);

        if (isExplicitInvalid) {
          throw new Error('invalid');
        }

        if (!response.ok) {
          throw new Error('unreachable');
        }

        setAuthState(resolveLocalAuthState(user));
      })
      .catch((error) => {
        if (error?.message !== 'invalid') {
          setAuthState(resolveLocalAuthState(user));
          return;
        }
        localStorage.removeItem('user');
        localStorage.removeItem('rememberToken');
        setAuthState('signin');
      });
  }, []);

  if (authState === 'checking') return null;
  if (authState === 'signin') return <Navigate to="/signin" replace />;
  if (authState === 'profile') return <Navigate to="/profile-picture" replace />;
  return children;
}

export default ProtectedRoute;
